import React, { useCallback, useState } from "react";
import { useBoardContext } from "@rastreabilidadebrasil/tageditor";
import { Button, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { FileEarmark, CloudDownload } from "react-bootstrap-icons";
import { useEditorContext } from "../../../../../context/editorContext/EditorContext";
import { useMessage } from "../../../../../context/alertContext/context";
import { useTranslation } from "react-i18next";

interface IExtra {
  tagData: {
    sku: string;
  };
}

type OpenProps = {
  setOpenModalMinhasEtiquetas: (value: boolean) => void;
  onLoadEvent?: (ev: ProgressEvent<FileReader>) => void;
  vertical: boolean;
  openOnHover: boolean;
};

const Open = ({
  setOpenModalMinhasEtiquetas,
  onLoadEvent: onLoadEventProp,
  vertical,
  openOnHover,
}: OpenProps) => {
  const { boardFile } = useBoardContext();
  const { fileExtension, selecionarProduto, produtosEditor } = useEditorContext();

  const { showAlertApp } = useMessage();
  const { t } = useTranslation("editor");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleLoadEvent = (ev: ProgressEvent<FileReader>) => {
    const json = ev?.target?.result as string;
    boardFile
      ?.import(json)
      .then((data) => {
        if (data.extra) {
          const produtoSelecionado = produtosEditor.find(
            (x) => x.sku === (data.extra! as IExtra).tagData.sku,
          );
          if (produtoSelecionado) selecionarProduto(produtoSelecionado);
        } else {
          showAlertApp("Produto inválido", "warning", 5000);
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

  const upload = useCallback(() => {
    const inputEl = document.createElement("input");
    inputEl.accept = fileExtension;
    inputEl.type = "file";
    inputEl.hidden = true;

    inputEl.onchange = (e) => {
      const element = e.target as HTMLInputElement;
      if (element?.files?.length) {
        const reader = new FileReader();
        reader.onload = (ev) => {
          if (onLoadEventProp) {
            onLoadEventProp(ev);
          } else {
            handleLoadEvent(ev);
          }
        };
        reader.readAsText(element.files[0]);
      }
    };

    document.body.appendChild(inputEl);
    inputEl.click();
    inputEl.remove();
  }, [fileExtension, onLoadEventProp, handleLoadEvent]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        className="btn btn-header-editor"
        startIcon={<FileEarmark size={28} />}
        sx={{ flexDirection: vertical ? "column" : "row" }}
        onClick={handleClick}
        onMouseOver={openOnHover ? handleClick : undefined}
      >
        {t("Abrir")}
      </Button>

      <Menu
        elevation={1}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{ onMouseLeave: handleClose }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={upload}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#fff4d4";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <ListItemIcon>
            <FileEarmark size={20} />
          </ListItemIcon>
          {t("Abrir do computador")}
        </MenuItem>
        <MenuItem
          onClick={() => setOpenModalMinhasEtiquetas(true)}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#fff4d4";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <ListItemIcon>
            <CloudDownload size="20" />
          </ListItemIcon>
          {t("Abrir da nuvem")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default Open;
